import { Service } from "typedi";
import { HttpService } from "~shared/services/http.service";
import { ForceResetPasswordInterceptor } from "@/modules/auth/interceptors/force-reset-password.interceptor";
import { DefaultErrorInterceptor } from "~shared/interceptors/default-error.interceptor";
import { InvalidSessionInterceptor } from "@/modules/auth/interceptors/invalid-session.interceptor";
import { InsufficientAccessInterceptor } from "@/modules/auth/interceptors/insufficient-access.interceptor";

@Service()
export class RestService extends HttpService {
  constructor() {
    super();

    this.useInterceptors(
      ForceResetPasswordInterceptor,
      InvalidSessionInterceptor,
      InsufficientAccessInterceptor,
      DefaultErrorInterceptor
    );
  }
}
